import { render, staticRenderFns } from "./Provide.vue?vue&type=template&id=3c0cbaf4&scoped=true"
import script from "./Provide.vue?vue&type=script&lang=js"
export * from "./Provide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0cbaf4",
  null
  
)

export default component.exports